import React from 'react';
import { useTheme } from '../../styling';
import { DROPDOWN_TAGS_CLASS_PREFIX } from './constants';
import { useDropdownTagsClassName } from './utils/useDropdownTagsClassName';
import { DropdownTag } from './style';
export var DropdownTags = function DropdownTags(_ref) {
  var className = _ref.className,
      disabled = _ref.disabled,
      tagsToDisplay = _ref.tagsToDisplay,
      propsFn = _ref.propsFn;
  var theme = useTheme().armor;
  var classOverride = useDropdownTagsClassName(DROPDOWN_TAGS_CLASS_PREFIX, className, disabled);
  return React.createElement(React.Fragment, null, tagsToDisplay.map(function (option) {
    return React.createElement(DropdownTag, Object.assign({}, propsFn(option), {
      className: classOverride.Root,
      theme: theme,
      key: option.value,
      small: true
    }));
  }));
};